import React from "react";
import { RIPE_LEMON, OLIVE, TRAVERTINE } from "../../../../constants/style/colors";
import * as S from "../../style";
import EntityLink from "../../../shared/EntityLink";

function TruckCell({ truck, entityLinkOptions }) {
    return truck && truck.id ? (
        <EntityLink
            entity={truck}
            options={entityLinkOptions}
            hideAvatar
        />
    ) : (
        <S.StyledBadge
            textColor={OLIVE}
            borderColor={RIPE_LEMON}
            color={TRAVERTINE}
        >
            <span>No truck assigned</span>
        </S.StyledBadge>
    );
}

export default TruckCell;
